import React from 'react';

export default function DirectionLine() {
    return (
        <div className='UniversalHeadline'>
            <h6 className='mainHeading'>ASSOCIATE INFORMATION AND PRE-ONBOARDING FORM</h6>
            <p><b>Note:</b>Please update all cells with correct and relevant data. The information provided in this document will form part of your official records in the Company and is subjected to verification.</p>
        </div>
    )
}
